// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Twmf","col":"styles_col__2VGPD"};